module.exports = __webpack_public_path__ + "static/media/thcentury.f2ff8255.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/history/thcentury.png
// module id = 193
// module chunks = 0